import request from '@/utils/request'

/** 违规类型字典：文案由后端下发，前端不写死 */
export function getSensitiveWordCategories() {
  return request({
    url: '/admin/sensitive-word/categories',
    method: 'get'
  })
}

export function getSensitiveWordList(query) {
  return request({
    url: '/admin/sensitive-word/list',
    method: 'get',
    params: query
  })
}

export function createSensitiveWord(data) {
  return request({
    url: '/admin/sensitive-word',
    method: 'post',
    data
  })
}

export function updateSensitiveWord(data) {
  return request({
    url: '/admin/sensitive-word',
    method: 'put',
    data
  })
}

export function deleteSensitiveWord(id) {
  return request({
    url: `/admin/sensitive-word/${id}`,
    method: 'delete'
  })
}
